// extracted by mini-css-extract-plugin
export default {"container":"Text_container__P+zL-"};